// extracted by css-extract-rspack-plugin
export default {"cls1":"JournalSubscriptionPage-cls1_Hgx","cls2":"JournalSubscriptionPage-cls2_H1B JournalSubscriptionPage-cls1_Hgx"};